import itemType from "./../../../services/stock/itemType";
import { arrayPushOrUpdateByID } from "../../../utils/toolkit";

export default {
    namespaced: true,
    state: {
        list: [],
        loading: false,
    },
    getters: {
        loading: (state) => state.loading,
        list: (state) => state.list,
    },
    mutations: {
        loading: (state, payload) => (state.loading = payload),
        push(state, payload) {
            state.list = arrayPushOrUpdateByID(state.list, payload);
        },
    },
    actions: {
        get(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("loading", true);
                itemType
                    .search(payload)
                    .then((response) => {
                        context.commit("push", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        context.commit("loading", false);
                    });
            });
        },
    },
};
